import UploadAvatar from './UploadAvatar'
export default UploadAvatar
